import { useEffect, useState } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { compose } from 'recompose'

import { FeatureFlags } from 'constants/security'
import { WrappedComponentType } from 'constants/types'

import auth from 'utils/auth'

import appSelectors from 'services/app/selectors'
import { withFormBuilderSettingsService, withFormBuilderSettingsServiceProps } from 'services/formBuilderSettings'
import formBuilderSettingsSelectors from 'services/formBuilderSettings/selectors'

import { RootState } from 'core/reducers'

import FormBuilderPreviewView from './FormBuilderPreviewView'

const mapState = (state: RootState, { params }) => ({
  isFinanceV3Enabled: auth.SELECTORS.getIsFinanceV3Enabled(state),
  nurseryFormBuilderSettings: formBuilderSettingsSelectors.getSettings(state),
  nurseryOptions: appSelectors.getContextNurseryRouterConfig(state, params),
})

const connector = connect(mapState)

type PropsFromRedux = ConnectedProps<typeof connector>

type FormBuilderPreviewContainerFullProps = PropsFromRedux
  & withFormBuilderSettingsServiceProps

const FormBuilderPreviewContainer: WrappedComponentType<FormBuilderPreviewContainerFullProps> = ({
  formBuilderSettingsActions,
  isFinanceV3Enabled,
  nurseryFormBuilderSettings,
  nurseryOptions,
}) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (nurseryOptions.id) {
      formBuilderSettingsActions.getAvailable({
        onSuccess: () => {
          setIsLoading(false)
        },
        params: [nurseryOptions.id],
      })
    }
  }, [nurseryOptions.id])

  return (
    <FormBuilderPreviewView
      isFinanceV3Enabled={isFinanceV3Enabled}
      isLoading={isLoading}
      nurseryFormBuilderSettings={nurseryFormBuilderSettings}
    />
  )
}

const enhance = compose(
  withFormBuilderSettingsService,
  connector,
)

FormBuilderPreviewContainer.authParams = {
  flags: [
    FeatureFlags.REGISTRATION_FORMS,
  ],
}

export default enhance(FormBuilderPreviewContainer)
